/* Product rating helper.
 * The visible widget is Judge.me's official preview badge (themed in
 * components/judgeme.css). Judge.me exposes the average as e.g. "4.50";
 * this mirrors a one-decimal version onto `data-sora-avg` so the CSS can
 * show "4.5". Judge.me renders asynchronously, so we observe until it appears.
 */
(() => {
  const wrap = document.querySelector('[data-sora-rating]');
  if (!wrap) return;

  const format = (badge) => {
    const avg = parseFloat(badge.getAttribute('data-average-rating') || '0');
    const value = (Math.round(avg * 10) / 10).toFixed(1);
    // Only write when it actually changes — avoids re-triggering the observer.
    if (badge.getAttribute('data-sora-avg') !== value) {
      badge.setAttribute('data-sora-avg', value);
    }
  };

  const run = () => {
    const badge = wrap.querySelector('.jdgm-prev-badge');
    if (!badge) return false;
    format(badge);
    return true;
  };

  if (run()) return;

  const obs = new MutationObserver(() => {
    if (run()) obs.disconnect(); // stop once the badge exists and is formatted
  });
  obs.observe(wrap, { childList: true, subtree: true });
  setTimeout(() => obs.disconnect(), 8000);
})();
